<div class="row pt-3 pb-3 mb-3 border-bottom" data-testing-id="product-list-item">
  <!-- Errors and Infos -->
  <div *ngIf="pli().validationError?.message" class="alert alert-inline alert-danger col-12">
    {{ pli().validationError.message }}
  </div>
  <div *ngIf="pli().info?.message" class="alert alert-inline alert-info col-12">
    {{ pli().info.message }}
  </div>

  <div class="col-8 col-md-8 col-xl-6">
    <div class="row">
      <!-- Action tab -->
      <div class="col-2 col-md-2 p-0 shopping-cart-action text-center">
        <!--temporary fix-->
        <span>
          <a
            *ngIf="!pli().isFreeGift && editable()"
            [attr.data-testing-id]="'remove-line-item'"
            [attr.data-id]="pli().id"
            title="{{ 'shopping_cart.remove.item.button.label' | translate }}"
            (click)="onDeleteItem(pli().id)"
            data-inline="true"
          >
            <fa-icon [icon]="['fas', 'trash-alt']" /> </a
        ></span>
      </div>
      <!-- Product Image -->
      <div class="col-4 px-2 col-md-4 mb-3">
        <!--temporary fix-->
        <ish-product-image imageType="S" />
      </div>

      <!-- Product Description -->
      <div class="col-6 col-md-6">
        <!--temporary fix-->
        <!--Product Description -->
        <div class="pli-description">
          <div class="product-name">
            <ish-product-name [alternate]="pli().name" />
          </div>

          <!-- Product ID -->
          <!-- <ish-product-id></ish-product-id> -->

          <!-- Product Variations -->
          <!-- <ish-product-variation-display></ish-product-variation-display> -->
          <!-- Product Bundles -->
          <!-- <ish-product-bundle-display></ish-product-bundle-display> -->

          <!-- switch by lineItemViewType -->
          <ng-container [ngSwitch]="lineItemViewType()">
            <!-- lineItemViewType = 'simple' -->
            <ng-container *ngSwitchCase="'simple'" />

            <!-- lineItemViewType = 'availability' -->
            <ng-container *ngSwitchCase="'availability'">
              <ish-product-inventory />
            </ng-container>

            <!-- default lineItemViewType -->
            <ng-container *ngSwitchDefault>
              <!-- edit variation & quantity -->
              <ng-container *ngIf="editable()">
                <ish-line-item-edit
                  *ngIf="!('preferences.ChannelPreferences.EnableAdvancedVariationHandling' | ishServerSetting)"
                  ishProductContext
                  [sku]="pli().productSKU"
                  [quantity]="pli().quantity.value"
                  [itemId]="pli().id"
                  (updateItem)="onUpdateItem($event)"
                />
              </ng-container>

              <!-- surcharges -->
              <div *ngFor="let surcharge of pli().itemSurcharges">
                {{ surcharge.displayName }} <span *ngIf="!surcharge.displayName">{{ surcharge.text }}</span>
                <span class="text-nowrap"> {{ surcharge.amount | ishPrice }} </span>
                <ng-template #SurchargeDescription> <span [innerHTML]="surcharge.description"></span> </ng-template>
                <a
                  class="details-tooltip"
                  [ngbPopover]="SurchargeDescription"
                  [popoverTitle]="surcharge.displayName"
                  placement="top"
                >
                  {{ 'shopping_cart.detail.text' | translate }}
                  <fa-icon [icon]="['fas', 'info-circle']" />
                </a>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <!-- mobile quantity -->
        <div class="quantity d-xl-none">
          <div class="form-group">
            <label class="d-xl-none col-form-label">{{ 'shopping_cart.pli.qty.label' | translate }}</label>
            <ish-product-quantity *ngIf="editable(); else readonly" />
            <ng-template #readonly>{{ pli().quantity.value | number }}</ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- desktop quantity -->
  <div class="col-3 col-xl-3 d-none d-xl-flex text-right">
    <div class="form-group w-100 text-right" [ngClass]="{ 'pr-2': !editable() }">
      <label class="d-xl-none col-form-label">{{ 'shopping_cart.pli.qty.label' | translate }}</label>
      <div class="product-quantity-box-shadow">
        <ish-product-quantity *ngIf="editable(); else readonly" />
      </div>
      <ng-template #readonly>{{ pli().quantity.value | number }}</ng-template>
    </div>
  </div>

  <!-- Prices -->

  <div *ngIf="pli().totals" class="col-4 col-md-4 col-xl-3 text-right">
    <div>
      <!-- (Suggested) Total Price  -->
      <div data-testing-id="total-price">{{ pli().totals.total | ishPrice }}</div>
    </div>

    <!-- Value Rebates Total -->
    <div *ngIf="pli().totals.valueRebatesTotal" class="old-price">
      <span class="price-value">{{ pli().totals.undiscountedTotal | ishPrice }}</span>
    </div>

    <!-- Gift -->
    <div *ngIf="pli().isFreeGift" class="list-item-promo">{{ 'checkout.pli.freegift.text' | translate }}</div>
  </div>

  <div class="col-sm-12">
    <ish-line-item-warranty [OnePageCheckout]="isOnePageCheckout" [pli]="pli()" [editable]="editable()" />
  </div>
</div>
